module.exports = __webpack_public_path__ + "img/9788963710808.f76a60b0.jpg";